import { useMemo } from "react";

import { Bulb } from "components/icons/generated";
import useIsOnboardingCertificatesAvailable from "hooks/useIsOnboardingCertificatesAvailable";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useInsightsGroup = (): MainNavigationItem | undefined => {
  const { viewer } = useTypedContext(AccountContext);
  const isOnboardingCertificatesAvailable = useIsOnboardingCertificatesAvailable();

  const isLaunchpadEnabledForUser = viewer.admin || isOnboardingCertificatesAvailable;

  const launchpadItem = useMemo(
    () =>
      isLaunchpadEnabledForUser
        ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Launchpad]]
        : [],
    [isLaunchpadEnabledForUser]
  );

  const notificationsItem = useMemo(
    () =>
      viewer.admin
        ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Notifications]]
        : [],
    [viewer.admin]
  );

  return useMemo(() => {
    return {
      id: "insights",
      title: "Get Insights",
      icon: Bulb,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Dashboard],
            ...launchpadItem,
            ...notificationsItem,
          ],
        },
      ],
    };
  }, [launchpadItem, notificationsItem]);
};

export default useInsightsGroup;
